<template>
  <v-container id="links" class="text-center py-10 px-0" max-width="none">
    <!-- SNSタグ   タグの内容はページ下部で設定 -->
    <SocialMediaTags :tags="hashtags" />

    <!-- SNSリンク -->
    <div class="mt-10">
      <v-row class="justify-center">
        <v-col cols="auto" v-for="link in links" :key="link.url">
          <a :href="link.url" target="_blank">
            <v-img
              width="36"
              :src="link.icon"
              :max-width="link.width"
              style="filter: brightness(10)"
            ></v-img>
          </a>
        </v-col>
      </v-row>
      <!-- バナー -->
      <v-container>
        <v-row class="mt-10 reveal justify-center align-center">
          <v-col cols="6">
            <a :href="$t('footer.banner.link')"
                target="_blank">
              <v-img
                :aspect-ratio="750 / 530"
                :src="`${basePath}${$t('footer.banner.image')}`"
                max-width="200px"
                class="mx-auto"
              ></v-img>
            </a>
          </v-col>
          <v-col cols="12" sm="10" md="8">
            <p
              class="text-body-2 text-pre-wrap text-center mt-3 mb-1"
              align="left"
              v-html="$t('footer.banner.description')"
            ></p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- SSLサーバ証明書サイトシール -->
    <GlobalSign />
    <div class="mt-7">
      <span class="white--text">&copy; {{ new Date().getFullYear() }} naked, inc.</span>
    </div>
    <!-- <nav class="pt-15 text-black">
      <router-link :to="`/${currentLang}/`">Home</router-link> |
      <router-link :to="`/${currentLang}/about`">About</router-link>
    </nav> -->
  </v-container>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { getBasePath } from '@/utils/basePath';
import GlobalSign from './GlobalSign.vue';
import SocialMediaTags from '@/components/SnsTag.vue';

// ハッシュタグ設定ファイルから読み込み
import hashtags from '@/config/hashtags';

const { t, locale } = useI18n();

//  現在の言語コードを定義
const currentLang = computed(() => locale.value);

//  ベースパスを定義
const basePath = computed(() => getBasePath());

const links = [
  {
    icon: `${basePath.value}Images/sns/icon_x.svg`,
    url: "https://twitter.com/naked_staff",
    width: "40",
  },
  {
    icon: `${basePath.value}Images/sns/icon_instagram.svg`,
    url: "https://www.instagram.com/naked_inc/",
    width: "40",
  },
  {
    icon: `${basePath.value}Images/sns/icon_youtube.svg`,
    url: "https://www.youtube.com/c/NAKEDINC",
    width: "40",
  },
  {
    icon: `${basePath.value}Images/sns/icon_tiktok.svg`,
    url: "https://www.tiktok.com/@nakedinc",
    width: "28",
  },
];


</script>
